import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {LiteratureReference} from "../model/graph/publication/literature-reference.model";

@Pipe({
  name: 'includeRef',
  standalone: true
})
export class IncludeRefPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {  }

  transform(text: string, refs: LiteratureReference[]): SafeHtml {
    refs
      .filter(ref => ref && ref.url)
      .forEach(ref => {
        let replacer = (match: string) => `<a href="${ref.url}">${match}</a>`
        text = text.replaceAll(new RegExp(`${ref.author[0].surname} ?${this.initials(ref.author[0].initial)}\\.? ?( et al[., ]{0,2})? ?${ref.year}`, 'g'), replacer);
        if (ref.author.length === 2) {
          let regExp = new RegExp(`${ref.author[0].surname} ?${this.initials(ref.author[0].initial)}\\.? ?(and|\&) ${ref.author[1].surname} ?${this.initials(ref.author[1].initial)}\\.? ?,? ${ref.year}`, 'g');
          text = text.replaceAll(regExp, replacer);
        }
      });
    return this.sanitizer.bypassSecurityTrustHtml(text)
  }

  initials(initials: string): string {
    return initials.split('').join('?') + '?'
  }

}
